export enum Time {
  OneMinute = 1000 * 60,
  TwoMinutes = 1000 * 60 * 2,
  ThreeMinutes = 1000 * 60 * 3,
  FiveMinutes = 1000 * 60 * 5,
  TenMinutes = 1000 * 60 * 10,
  FifteenMinutes = 1000 * 60 * 15,
  ThirtyMinutes = 1000 * 60 * 30,
  OneHour = 1000 * 60 * 60,
  TwoHours = 1000 * 60 * 60 * 2,
  ThreeHours = 1000 * 60 * 60 * 3,
}
